import React from 'react'
import { SlButton, SlIcon } from '@shoelace-style/shoelace/dist/react'

// react-select renders inside the table's overflow-auto scroll container, so the
// menu must be portalled to body or it gets clipped by the container edge.
export const selectStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  control: (base) => ({ ...base, minHeight: 36, borderRadius: 8, borderColor: '#e2e8f0' }),
  menu: (base) => ({ ...base, fontSize: 14 }),
}

export const selectProps = {
  styles: selectStyles,
  menuPortalTarget: document.body,
  menuPlacement: 'auto',
}

function EditableCell({ editing, canEdit = true, display, onEdit, onSave, onCancel, children }) {
  if (editing) {
    return (
      <div className="flex min-w-[240px] flex-col gap-2 py-1">
        {children}
        <div className="flex flex-wrap items-center gap-2">
          <SlButton variant="primary" size="small" onClick={onSave}>Save</SlButton>
          <SlButton variant="default" size="small" onClick={onCancel}>Cancel</SlButton>
        </div>
      </div>
    )
  }

  return (
    <div className="flex items-center justify-between gap-3">
      <span className="text-slate-700">{display || display === 0 ? display : '—'}</span>
      {canEdit && (
        <sl-tooltip content="Edit">
          <button
            type="button"
            onClick={onEdit}
            aria-label="Edit"
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-slate-200 text-slate-500 transition-colors hover:border-sky-400 hover:text-sky-500"
          >
            <SlIcon library="lucide" name="pencil"></SlIcon>
          </button>
        </sl-tooltip>
      )}
    </div>
  )
}

export default EditableCell
